import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSettingsChangedParameters
    extends TrackEventBaseParameters<null, "defaults_changed" | "subscription_status_changed"> {}

const trackSettingsChanged = (
    parameters: TrackSettingsChangedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "settings_changed", ...parameters }, options);
};

export default trackSettingsChanged;
